import { render, staticRenderFns } from "./PhonePreview.vue?vue&type=template&id=12af253e&scoped=true"
import script from "./PhonePreview.vue?vue&type=script&lang=js"
export * from "./PhonePreview.vue?vue&type=script&lang=js"
import style0 from "./PhonePreview.vue?vue&type=style&index=0&id=12af253e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af253e",
  null
  
)

export default component.exports